import React from "react";

import { Container, Row, Col, Card, Button } from "reactstrap";

function Attend() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      <div
        style={{
          backgroundColor: "transparent",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="section section-with-space"
        data-parallax={true}
      >
        <div className="filter" />
        <Container className={""}>
          <Row>
            <Col md="12">
              <h1
                className=" text-left text-g mb-3 text-dark"
                style={{
                  fontSize: size ? "3rem" : "2rem",
                }}
              >
                WHO MUST ATTEND?
              </h1>
              <p className="text-400 text-dark mb-5">
                The conference is designed for senior decision-makers, innovators, and practitioners
                across the public and private sectors, including:
              </p>
            </Col>
            {content.map((c, i) => (
              <Col lg={4} xs={12} className="px-1" key={c.title}>
                <Card
                  className=""
                  style={{
                    background: i % 2 !== 0 ? "#00a8c4" : "#3e3f99",
                    height: size ? "90px" : "none",
                  }}
                >
                  <div className="d-flex p-2 align-items-center">
                    <div className="px-2 align-self-center">
                      <img
                        src={require(`assets/icons/${c.image}`)}
                        style={{ width: "70px" }}
                        width="100%"
                        alt="about"
                      />
                    </div>
                    <p className="text-400 py-2 text-white mb-0">{c.title}</p>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
          <Row className="justify-content-center">
            <Col lg={3} className="text-center px-1 mt-5">
              <Button
                href="/register"
                className="rounded-0 text-400 text-white"
                color="info"
                size="lg"
                rel="noopener noreferrer"
                target="_blank"
                style={{ background: "#3e3f99" }}
              >
                <span
                  style={{
                    color: "#fff",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                >
                  REGISTER NOW
                </span>
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

const content = [
  { title: "CENTRAL GOVERNMENT DEPARTMENTS", image: "Asset 15.png" },
  { title: "LOCAL AUTHORITIES & CITY COUNCILS", image: "Asset 23.png" },
  { title: "URBAN PLANNING & REGENERATION AGENCIES", image: "Asset 18.png" },
  { title: "TRANSPORT AUTHORITIES & RAIL OPERATORS", image: "Asset 19.png" },
  { title: "ENERGY & UTILITY COMPANIES", image: "Asset 22.png" },
  { title: "PROPERTY DEVELOPERS & REAL ESTATE FIRMS", image: "Asset 18.png" },
  { title: "ARCHITECTURE, ENGINEERING & CONSTRUCTION (AEC) PROFESSIONALS", image: "Asset 17.png" },
  { title: "DIGITAL ENGINEERING, BIM & GIS LEADERS", image: "Asset 14.png" },
  { title: "SMART CITY AND URBAN PLANNING PROGRAMME MANAGERS", image: "Asset 23.png" },
  { title: "TECHNOLOGY & SOFTWARE PROVIDERS", image: "Asset 8.png" },
  { title: "UNIVERSITIES & RESEARCH INSTITUTIONS", image: "Asset 21.png" },
  { title: "CONSULTANTS AND SYSTEM INTEGRATORS", image: "Asset 16.png" },
];

export default Attend;
